import type { HTMLAttributes, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/shared/utils/cn';

export interface FilterBarProps extends HTMLAttributes<HTMLElement> {
  children: ReactNode;
}

export function FilterBar({ children, className, ...rest }: FilterBarProps) {
  const { t } = useTranslation('common');
  return (
    <section
      className={cn(
        'flex flex-col gap-2 rounded-md border border-border bg-surface p-3 shadow-sm sm:flex-row sm:flex-wrap sm:items-center',
        className,
      )}
      aria-label={t('ui.filterBar.aria')}
      {...rest}
    >
      {children}
    </section>
  );
}
